/**
 * Work page, opening — "Every shop on the street": the covers in a browser
 * on the paper side, the project files listed in a terminal at night. The
 * markup is the server's (templates/site/sections/work/opening.html.twig).
 *
 * @module sections/work/opening
 */

import { animateSplitAway } from '../../components/split.js';

export const animate = animateSplitAway;
